export default __webpack_public_path__ + "static/media/Group 2@2x.91fb52ef.png";